'use client';
/** @jsxImportSource @emotion/react */

import { type SVGProps } from 'react';
const WarningOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height={24}
    viewBox="0 0 24 24"
    width={24}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 5.99 19.53 19H4.47L12 5.99ZM12 2 1 21h22L12 2Z"
      fill="currentColor"
    />
    <path d="M13 16h-2v2h2v-2ZM13 10h-2v5h2v-5Z" fill="currentColor" />
  </svg>
);
export default WarningOutlined;
